import React, {Component} from 'react'
import {toJS} from 'mobx'
import {inject, observer} from 'mobx-react'
import {getPaginationConfig} from '../../../components/pagination'
import {Table, Button, Modal, Tag} from 'antd'
import { QuestionCircleFilled, DeleteOutlined, CheckCircleOutlined, CloseCircleOutlined, ClockCircleOutlined, StopOutlined} from '@ant-design/icons'
import {withTranslation} from 'react-i18next'
const {confirm} = Modal

@inject('marketingShortLinkStore')
@observer
class SearchResult extends Component {
  state = {
  }

  componentDidMount() {
  }
  handleLink = (record) => {
    const {marketingShortLinkStore,t} = this.props
  }
  handleDel = (record) => {
    const {marketingShortLinkStore,t} = this.props
    confirm({
      title: t(`general.deleteData`),
      icon: <QuestionCircleFilled/>,
      content: t(`general.sureToDelete`),
      okText: t(`general.delete`),
      cancelText: t(`general.cancel`),
      onOk() {
        marketingShortLinkStore.onDeleteJobAction(record?.id)
      },
      onCancel() {
      },
    })
    return false
  }
  handlePageChange = (page, pageSize) => {
    const {marketingShortLinkStore} = this.props
    marketingShortLinkStore.onChangePageNumAction(page, pageSize)
  }
  getRowClassName = (record, index) => {
    let className = ''
    className = index % 2 === 0 ? 'oddRow' : 'evenRow'
    return className
  }
  render() {
    const {marketingShortLinkStore, t} = this.props
    const {pageNo, pageSize, itemCount, jobList, statusList, typeList, maxCreateCount} = marketingShortLinkStore
    const pagination = getPaginationConfig(pageNo, pageSize, itemCount, this.handlePageChange)
    return (
      <>
        <div className='shortLinkNum'>剩余短链数量：<span>{maxCreateCount}</span>个</div>
        <Table className="searchResult" dataSource={toJS(jobList)} pagination={pagination} rowKey="id" rowClassName={this.getRowClassName} scroll={{x: '110%'}} style={{marginTop: 0}} bordered>
          <Table.Column title={t(`marketingManagement.marketingGroup`)} dataIndex="marketingGroupName" key="marketingGroupName" ellipsis={true} />
          <Table.Column title={t(`marketingManagement.shortLinkName`)} dataIndex="shortLinkName" key="shortLinkName" ellipsis={true} />
          <Table.Column title={t(`marketingManagement.shortLinkStatus`)} dataIndex="status" key="status" ellipsis={true} render={(text, record) => 
            <Tag  color={text===1 ? "success" : text===2 ? "error" : text===3 || text===4 ? null : "cyan" }>
              {text ? text===1 ? <CheckCircleOutlined /> : text===2 ? <CloseCircleOutlined /> : text===3 || text===4 ? <StopOutlined /> : <ClockCircleOutlined /> : null}
              {' '}
              {statusList?.find(a=>parseInt(a?.code)===text)?.name}
            </Tag>
          } />
          <Table.Column title={t(`marketingManagement.shortLinkType`)} dataIndex="type" key="type" ellipsis={true} render={(text, record) => 
            typeList?.find(a=>a?.code===text)?.name
          } />
          <Table.Column title={t(`marketingManagement.oldShortLink`)} dataIndex="sourceLinkUrl" key="sourceLinkUrl" ellipsis={true}/>
          <Table.Column title={t(`marketingManagement.generateShortLink`)} dataIndex="shortLink" key="shortLink" ellipsis={true}/>
          <Table.Column title={t(`marketingManagement.createTime`)} dataIndex="createTime" key="createTime" ellipsis={true}/>
          <Table.Column title={t(`marketingManagement.expirationTime`)} dataIndex="expireTime" key="expireTime" ellipsis={true}/>
          <Table.Column width={150} align="center" fixed='right' title={t(`general.action`)} key="Action" render={(text, record) => (
            <>
              {/* <Button type="link" onClick={() => this.handleLink(record)} icon={<LinkOutlined/>} title={t(`general.link`)}/> */}
              <Button type="link" onClick={() => this.handleDel(record)} icon={<DeleteOutlined/>} title={t(`general.delete`)}/>
            </>
          )}/>
        </Table>
      </>
    )
  }
}

export default withTranslation()(SearchResult)
